var ALCHEMY_ID = '9j9SdF5HiwChoVUJLk-DaKNxU4Xm6ok1'; //process.env.ALCHEMY_ID
export var RPCs = {
    '1': "https://eth-mainnet.g.alchemy.com/v2/".concat(ALCHEMY_ID),
    '42161': "https://rpc.ankr.com/arbitrum",
    '10': 'https://optimism.gateway.tenderly.co/19XD817c4zNXz6xBFYnyLb',
    '8453': 'https://base-rpc.publicnode.com',
    '11155111': 'https://sepolia.gateway.tenderly.co/19XD817c4zNXz6xBFYnyLb',
};
